import React, {Fragment,useState, useEffect} from 'react'
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { CategoriaTitulo } from '../CategoriaTitulo';



export const EventosUsuario = (props) => {

    const history = useHistory();

   const navigateTo = (id) => {
        id != '-1' ?
        history.push(`/evento/${id}`)
        :
        history.push(`/`)
    }

   const [miseventos, setMiseventos] = useState(false)

   

    const fetchMiseventos = async () => {
        let dataFormEventos = {  
            "idUsuario":localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-idu`),
         }
        
         let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-token`)}`
            },  
        };
        axios.post(`${process.env.REACT_APP_URL_API}eventos/EventosUsuario`, dataFormEventos, axiosConfig)
        .then((res) => {
            setMiseventos(res.data.data)
        })
        .catch((err) => {
            
        }) 
    }

    useEffect(() => {
        fetchMiseventos();
    },[])
    if(!miseventos) { return(<div></div>) }  
    return  (
        <Fragment>
           
                <div className="row miseventos">
                    <div className="col-lg-12 col-md-12">
                        <h2>Eventos a los que estás inscrito</h2>
                        <div className="contenedor-slider">
                        <div className="listadoItems">
                            { miseventos.map(item =>
                            <Fragment>
                                <div>
                                <div className="caja">
                                <div className="card">
                                    <img  className="card-img-top" onClick={() => navigateTo(item.idEvento)} src={item.logo !== null? item.logo : `${process.env.REACT_APP_SITE_URL}assets/images/eventoDefault.png`} alt="Card image cap" />
                                        <div className="card-body">
                                            <div>
                                                { item.eventosCategorias.map(categoria =>
                                                           
                                                           <CategoriaTitulo key={Math.random() * 57005} idCategoria={categoria.idCategoria} />
                                                )}
                                                <h5 className="card-title" onClick={() => navigateTo(item.idEvento)} >{item.nombre}</h5>
                                                <p className="card-text" >{item.descripcion}</p>
                                                <div className="emision">  
                                                    <div className="emision-day">
                                                        <span className="float-left">{new Date(item.fechaEvento).getDate()}</span> 
                                                        <span className="emision-month">{new Date(item.fechaEvento).toLocaleString('es-Es', { month: 'short' })}</span>
                                                    </div>
                                                    <div className="emision-hour">
                                                        <span className="">{item.lugarEvento} | {item.precio}</span>
                                                        <span className="">{item.horaInicio} </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="div-btn">
                                                <span  className="btn btn-primary margin-top-20" onClick={() => navigateTo(item.idEvento)} >ver más </span> 
                                            </div>
                                        </div>
                                        
                                    </div>
                                    </div>
                                    </div>
                            </Fragment>
                            )}
                        </div>
                        </div>           
                    </div>
                </div>
          
        </Fragment> 
    )
    
}